import { CRTDroitsEnum } from 'src/app/crt/models/crtDroit';
import { UserProfil } from './user-profile.model';

/**
 * Class user
 *
 * Voir {@link UserService} qui l'utilise
 */
export class User {
  id: string;

  nom: string;

  prenom: string;

  msisdn: string;

  profils: UserProfil[];

  matricule: string;

  email: string;

  idadfs: string;

  dkCodeRessource: string;

  categorie: string;

  CRTdroits: CRTDroitsEnum[];

  passwordExpiryDate: Date;

  dkCodeSociete: string;

  constructor(
    id: string,
    nom: string,
    prenom: string,
    msisdn: string,
    profils: UserProfil[],
    matricule: string,
    email: string,
    idadfs: string,
    dkCodeRessource: string,
    categorie: string,
    dkCodeSociete: string
  ) {
    this.id = id;
    this.nom = nom;
    this.prenom = prenom;
    this.msisdn = msisdn;
    this.profils = profils;
    this.matricule = matricule;
    this.email = email;
    this.idadfs = idadfs;
    this.dkCodeRessource = dkCodeRessource;
    this.dkCodeSociete = dkCodeSociete;
    this.categorie = categorie;
  }

  public isDiffu(): boolean {
    return this.profils.some((role) => role === UserProfil.Diffus);
  }

  public is(profil: UserProfil): boolean {
    return this.profils.some((role) => role === profil);
  }

  public isSuperAdmin(): boolean {
    return this.profils.some((role) => role === UserProfil.SuperAdmin);
  }

  public sameCompany(user: User) {
    return this.dkCodeSociete && user.dkCodeSociete && user.dkCodeSociete === this.dkCodeSociete;
  }
}
